import React, { forwardRef } from 'react';
const FormControlErrorIcon = (StyledFormControlErrorIcon) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledFormControlErrorIcon ref={ref} {...props}>
        {children}
      </StyledFormControlErrorIcon>);
});
export default FormControlErrorIcon;
